import { TelemetryFn } from "./TelemetryFn";

export interface ILog {
  pageView(pagePath: string): void;
  event(label: string, category: string, action: string): void;
  callTelemetryFn(type: string, data: {}): void;
}
export class Log implements ILog {
  public constructor(private telemetryFn: TelemetryFn, private name: string) {}

  public pageView(pagePath: string) {
    const data = {
      pagePath,
    };
    this.callTelemetryFn("PageView", data);
  }

  public event(label: string, category: string, action: string) {
    const data = {
      label,
      category,
      action,
    };
    this.callTelemetryFn("Event", data);
  }

  public callTelemetryFn(type: string, data: any) {
    if (this.telemetryFn && this.telemetryFn.apply) {
      const metadata = {
        name: this.name,
        type,
      };
      const args = [metadata, data];
      this.telemetryFn.apply(null, args);
    }
  }
}
